import { render, staticRenderFns } from "./CompanyStep.vue?vue&type=template&id=36a95e9f&scoped=true&"
import script from "./CompanyStep.vue?vue&type=script&lang=js&"
export * from "./CompanyStep.vue?vue&type=script&lang=js&"
import style0 from "./CompanyStep.vue?vue&type=style&index=0&id=36a95e9f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a95e9f",
  null
  
)

export default component.exports